// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__1evJE"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/index.scss
// module id = iIaB
// module chunks = 0